import React from 'react';
import './PageLoader.css';

function PageLoader() {
  return (
    <div className="page-loader-overlay" aria-live="polite" aria-busy="true">
      <div className="page-loader" />
    </div>
  );
}

export default PageLoader;
